import classnames from 'classnames'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import app from '../../../app.jsx'
import Button from '../../../common/common/button/button.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import DialogPhaseSetting from '../../../common/dialog/dialog_phase_setting/dialog_phase_setting.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import DateRangePicker from '../../../common/form/daterange_picker/daterange_picker.jsx'
import Acl from '../../../lib/acl.jsx'
import BudgetUtil from '../../../lib/budgetutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import PopupBudgetStatus from '../../popup/popup_budget_status/popup_budget_status.jsx'
import EstimateBudgetItem from '../estimate_budget_item/estimate_budget_item.jsx'
import ProjectBudgetItem from '../project_budget_item/project_budget_item.jsx'
import { calculateGroupSellingPrice, useSmallText } from './utils.js'

class EstimateBudgetPhaseBase extends Component {
  static propTypes = {
    activityList: PropTypes.array,
    budget: PropTypes.object,
    calculateMarkupPercentage: PropTypes.func,
    calculateSellingPrice: PropTypes.func,
    calculateSpentAmount: PropTypes.func,
    connectDragSource: PropTypes.func,
    contactName: PropTypes.string,
    disabledEdit: PropTypes.bool,
    dragPhaseItem: PropTypes.object,
    estimateActivityList: PropTypes.array,
    estimateBudget: PropTypes.array,
    estimatePhaseList: PropTypes.array,
    estimateRateCards: PropTypes.array,
    filterType: PropTypes.string,
    getItemPosition: PropTypes.func,
    hideDateRange: PropTypes.bool,
    isDiscountPhase: PropTypes.bool,
    isDragLayer: PropTypes.bool,
    isEstimate: PropTypes.bool,
    isItemDragging: PropTypes.bool,
    isQuickbookConnected: PropTypes.bool,
    onAddExpense: PropTypes.func,
    onChange: PropTypes.func,
    onChangePhaseStatus: PropTypes.func,
    onCopy: PropTypes.func,
    onCreateContact: PropTypes.func,
    onCreateItemSupplier: PropTypes.func,
    onCreatePurchaseOrder: PropTypes.func,
    onCreateTaxRate: PropTypes.func,
    onDeleteItemSupplier: PropTypes.func,
    onDeleteSubtotal: PropTypes.func,
    onDragEnd: PropTypes.func,
    onDragStart: PropTypes.func,
    onEditExpense: PropTypes.func,
    onItemCreate: PropTypes.func,
    onItemRemove: PropTypes.func,
    onItemUpdate: PropTypes.func,
    onMoveItem: PropTypes.func,
    onPhaseToggle: PropTypes.func,
    onRemove: PropTypes.func,
    onSave: PropTypes.func,
    onSearchSupplier: PropTypes.func,
    onUpdateItemReorder: PropTypes.func,
    onUpdateTotal: PropTypes.func,
    onViewPurchaseOrder: PropTypes.func,
    phase: PropTypes.object,
    phaseList: PropTypes.array,
    poDownloadBaseUrl: PropTypes.string,
    processPhaseSelect: PropTypes.func,
    projectBudget: PropTypes.object,
    projectCloseDate: PropTypes.any,
    projectEndDate: PropTypes.object,
    projectStartDate: PropTypes.object,
    projectTitle: PropTypes.string,
    quickbookItems: PropTypes.array,
    rate: PropTypes.number,
    rateCards: PropTypes.array,
    rateMarkup: PropTypes.number,
    reloadQuickbookItems: PropTypes.func,
    showActivity: PropTypes.bool,
    showDate: PropTypes.bool,
    showDefaultVat: PropTypes.bool,
    showLabelType: PropTypes.bool,
    showRate: PropTypes.bool,
    showTax: PropTypes.bool,
    showVatAutocomplete: PropTypes.bool,
    taxRateVatOptions: PropTypes.array,
    vatLevels: PropTypes.array,
    vatRate: PropTypes.number
  }

  static get defaultProps () {
    return {
      activityList: [],
      budget: null,
      calculateMarkupPercentage: null,
      calculateSellingPrice: null,
      calculateSpentAmount: null,
      connectDragSource: null,
      contactName: '',
      disabledEdit: false,
      dragPhaseItem: null,
      estimateActivityList: [],
      estimateBudget: [],
      estimatePhaseList: [],
      estimateRateCards: [],
      filterType: 'all',
      getItemPosition: null,
      hideDateRange: false,
      isDragLayer: false,
      isEstimate: false,
      isQuickbookConnected: false,
      onAddExpense: null,
      onChange: null,
      onChangePhaseStatus: null,
      onCopy: null,
      onCreateContact: null,
      onCreateItemSupplier: null,
      onCreatePurchaseOrder: null,
      onCreateTaxRate: null,
      onDeleteItemSupplier: null,
      onDeleteSubtotal: null,
      onDragEnd: null,
      onDragStart: null,
      onEditExpense: null,
      onItemCreate: null,
      onItemRemove: null,
      onItemUpdate: null,
      onMoveItem: null,
      onPhaseToggle: null,
      onRemove: null,
      onSave: null,
      onSearchSupplier: null,
      onUpdateItemReorder: null,
      onUpdateTotal: null,
      onViewPurchaseOrder: null,
      phase: null,
      phaseList: [],
      poDownloadBaseUrl: '',
      processPhaseSelect: null,
      projectBudget: null,
      projectCloseDate: null,
      projectEndDate: null,
      projectStartDate: null,
      projectTitle: '',
      quickbookItems: [],
      rateCards: [],
      rateMarkup: 0,
      reloadQuickbookItems: null,
      showActivity: true,
      showDate: false,
      showDefaultVat: false,
      showLabelType: false,
      showRate: false,
      showTax: false,
      showVatAutocomplete: false,
      taxRateVatOptions: [],
      vatLevels: [],
      vatRate: 0
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      editable: false,
      expanded: true
    }

    this.data = {
      phaseKeyword: '',
      activityKeyword: ''
    }

    this._references = {
      triggerStatus: React.createRef(),
      phasestatus: React.createRef(),
      phaseConfirmDelete: React.createRef(),
      phaseSettingDialog: React.createRef()
    }
  }

  componentDidMount () {
    window.rootApp.addEventListener('click', this._handleDocumentClick)
  }

  componentWillUnmount () {
    window.rootApp.removeEventListener('click', this._handleDocumentClick)
  }

  render () {
    const { phase, dragPhaseItem, isDragLayer } = this.props

    if (!phase) {
      return null
    }

    const isDragging = dragPhaseItem
      ? dragPhaseItem.dragItemType === 'phase' &&
        dragPhaseItem.dragId === phase.dragId
      : false
    const statusClass = classnames('bdgtphase', phase.status.toLowerCase(), {
      bdgtphase_isdragging: isDragging,
      bdgtphase_hidecontent: !!dragPhaseItem
    })

    const expanded = phase.expanded
    let _className = 'phasepanel'
    if (expanded) {
      _className = 'phasepanel expanded'
    } else if (expanded === false) {
      _className = 'phasepanel disabled'
    }

    return (
      <div className={statusClass}>
        <div className={_className}>
          {this.props.isEstimate
            ? this._renderEstimatePhaseHeader()
            : this._renderProjectPhaseHeader()}
          {phase.showAdd &&
            !this.props.isEstimate &&
            this._renderActivityAction()}
          {phase.showAdd &&
            this.props.isEstimate &&
            this._renderEstimateActivityAction()}
          {!isDragLayer && this._renderPhaseGroups()}
        </div>
        <div className='phaseactions' />
      </div>
    )
  }

  _renderEstimateActivityAction () {
    return (
      <div className='phaseactions'>
        <span
          className='phaseitem-close'
          onClick={this._onShowPhaseAddAction.bind(this, false)}
        >
          <i className='icon icon-phase-close' />
        </span>
        <div className='action'>
          <Button
            className='button_phase'
            title='project.viewBudget.addActivity'
            onClick={this._onAddPhaseItem.bind(this, 'time-activity', 0)}
          />
          <Button
            className='button_phase'
            title='project.viewBudget.text'
            onClick={this._onAddPhaseItem.bind(this, 'text', 0)}
          />
        </div>
      </div>
    )
  }

  _renderActivityAction () {
    const bFilterExpense = this._isFilterByExpense()
    const bFilterTime = this._isFilterByTime()

    return (
      <div className='phaseactions'>
        <span
          className='phaseitem-close'
          onClick={this._onShowPhaseAddAction.bind(this, false)}
        >
          <i className='icon icon-phase-close' />
        </span>
        <div className='action'>
          {!bFilterExpense && (
            <Button
              className='button_phase'
              title='project.viewBudget.timeActivity'
              onClick={this._onAddPhaseItem.bind(this, 'time-activity', 0)}
            />
          )}
          {!bFilterTime && (
            <Button
              className='button_phase'
              title='project.viewBudget.expense'
              onClick={this._onAddPhaseItem.bind(this, 'expense-activity', 0)}
            />
          )}
          {!bFilterTime && !bFilterExpense && (
            <Button
              className='button_phase'
              title='project.viewBudget.text'
              onClick={this._onAddPhaseItem.bind(this, 'text', 0)}
            />
          )}
        </div>
      </div>
    )
  }

  _handleDocumentClick = ev => {
    const phase = this.props.phase
    if (
      phase.showAdd &&
      !Util.targetIsDescendant(ev, ReactDOM.findDOMNode(this))
    ) {
      this._onShowPhaseAddAction(false)
    }
  }

  _onSave () {
    if (this.props.onSave) {
      this.props.onSave(this.props.phase)
    }
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.props.phase)
    }
  }

  _onChangeActivity (group, activity) {
    const phase = this.props.phase
    group.items.map((obj, _objIdx) => {
      if (obj.dragId === activity.dragId) {
        obj = activity
      }
    })

    if (activity.type === 'subtotal') {
      // Called when activity type is changed to subtotal
      this._calculateGroupSubtotal(group)
      const groupId = phase.groups.length + 1
      const newActv = this._createNewActivity('time-activity', phase, groupId)

      phase.groups.push({
        id: groupId,
        items: [newActv]
      })
    }

    this._onChange(phase)
  }

  _calculateGroupSubtotal (group) {
    let total = 0
    group.items.map((item, _idx) => {
      if (item.type === 'subtotal') {
        item.total = total
      } else {
        total += parseFloat(item.total || '0')
      }
    })
  }

  _onSaveActivity (group, activity) {
    group.items.map(obj => {
      if (obj.title === activity.title) {
        obj = activity
      }
    })

    this._onSave()
  }

  _onInsertItemInMiddle (item, type, e) {
    let currItemIdx = 0
    if (this.props.phase.groups.length > 0) {
      this.props.phase.groups[0].items.map((obj, idx) => {
        if (item.dragId === obj.dragId) {
          currItemIdx = idx
        }
      })
    }

    if (type === 'pagebreak') {
      this._onAddPageBreaker(type, currItemIdx + 1, e)
    } else {
      this._onAddPhaseItem(type, currItemIdx + 1, e)
    }
  }

  _onAddPhaseItem (type, insertIdx, e) {
    e.preventDefault()

    const phase = this.props.phase
    phase.showAdd = false
    phase.editable = false

    if (phase.groups.length === 0) {
      phase.groups.push({
        id: 0,
        items: []
      })
    }

    const lastIndex = phase.groups.length - 1
    const group = phase.groups[lastIndex]

    const activity = this._createNewActivity(type, phase, group.id)
    activity.orderNo = insertIdx + 1
    group.items.splice(insertIdx, 0, activity)

    group.items.map((item, idx) => {
      item.showAdd = false
      item.orderNo = idx + 1
    })

    if (type === 'subtotal') {
      phase.groups.push({
        id: lastIndex + 1,
        items: []
      })

      if (this.props.onUpdateTotal) {
        this.props.onUpdateTotal()
      }

      if (this.props.onItemCreate) {
        this.props.onItemCreate(activity)
      }
    }

    // If inserted at middle of the phase items, update order number for all items
    if (insertIdx !== group.items.length && this.props.onUpdateItemReorder) {
      this.props.onUpdateItemReorder()
    }

    this._onSave()
  }

  _onAddPageBreaker (type, insertIdx, e) {
    e.preventDefault()

    const phase = this.props.phase
    phase.editable = false

    if (phase.groups.length === 0) {
      phase.groups.push({
        id: 0,
        items: []
      })
    }

    const lastIndex = phase.groups.length - 1
    const group = phase.groups[lastIndex]

    const activity = this._createNewActivity(type, phase, group.id)
    activity.title = 'pagebreak'
    activity.orderNo = insertIdx - 1

    group.items.splice(insertIdx, 0, activity)

    group.items.map((item, idx) => {
      item.showAdd = false
      item.orderNo = idx + 1
    })

    if (this.props.onItemCreate) {
      this.props.onItemCreate(activity)
    }

    // If inserted at middle of the phase items, update order number for all items
    if (insertIdx !== group.items.length && this.props.onUpdateItemReorder) {
      this.props.onUpdateItemReorder()
    }

    this._onSave()
  }

  _createNewActivity (type, phase, groupId) {
    return BudgetUtil.createNewActivity(
      this.props.budget,
      type,
      phase,
      groupId,
      !!this.props.isEstimate,
      this.props.vatRate,
      this.props.rateMarkup,
      this.props.rate
    )
  }

  _onClickStatus (e) {
    e.preventDefault()
    if (
      (!this._isEditEnabled() && Acl.isReopenAllowed()) ||
      this._isEditEnabled()
    ) {
      e.preventDefault()

      if (this._references.phasestatus.current) {
        this._references.phasestatus.current.show()
      }
      this.forceUpdate()
    }
  }

  _onKeyPressTitleInput (bNext, ev) {
    const phase = this.props.phase

    if (ev.keyCode === 13 || ev.keyCode === 9) {
      // User press enter or tab
      ev.preventDefault()
      ev.stopPropagation()

      if (!bNext) {
        phase.editable = 'daterange'

        this.setState({ dataDate: new Date() })
      }
    } else if (ev.keyCode === 27) {
      phase.editable = 'daterange'

      this._onSave()
      this.setState({ dataDate: new Date() })
    }
  }

  _onSelectDate (fromDate, toDate) {
    const phase = this.props.phase
    phase.fromDate = fromDate || null
    phase.toDate = toDate || null

    if (fromDate && toDate && fromDate.getTime() > toDate.getTime()) {
      phase.fromDate = null
      phase.toDate = null
    }

    phase.editable = false

    this._moveToPhaseActivity()

    this._onSave()
  }

  _onCloseDate (phase) {
    phase.editable = false
    this.setState({ dataDate: new Date() })
  }

  _moveToPhaseActivity () {
    const phase = this.props.phase
    if (phase.groups && phase.groups.length > 0) {
      if (phase.groups[0].items) {
        if (phase.groups[0].items.length === 0) {
          const activity = this._createNewActivity(
            'time-activity',
            phase,
            phase.groups[0].id
          )
          phase.groups[0].items.push(activity)
        } else {
          const item = phase.groups[0].items[0]
          item.editable = 'title'
        }
      }
    }
  }

  _onEditPhase (name) {
    if (!this._isEditEnabled()) return

    const phase = this.props.phase
    phase.editable = name
    phase.bEdit = true

    this.setState({ dataDate: new Date() })
  }

  _onChangePhaseStatus (obj, hasDate) {
    if (obj.status !== 'closed' || hasDate) {
      if (this._references.phasestatus.current) {
        this._references.phasestatus.current.hide()
      }
    }

    const phase = this.props.phase
    phase.status = obj.status === 'reopen' ? 'completed' : obj.status

    // If status changed update activity status
    if (phase.groups && phase.groups.length > 0) {
      phase.groups.map(group => {
        if (group.items && group.items.length > 0) {
          group.items.map(item => {
            item.isActive = phase.status === 'active'
          })
        }
      })
    }

    this._onChange()

    if (this.props.onChangePhaseStatus) {
      this.props.onChangePhaseStatus(obj.closeDate)
    }
  }

  _onClickDeletePhase () {
    if (this._references.phaseConfirmDelete.current) {
      this._references.phaseConfirmDelete.current.show()
    }
  }

  _onDeletePhase (ev) {
    ev.preventDefault()

    let bItemUsed = false
    const phase = this.props.phase
    if (phase.groups && phase.groups.length > 0) {
      phase.groups.map(group => {
        bItemUsed = _.find(group.items, item => {
          return item.bUsed === true
        })
      })
    }

    if ((!bItemUsed) && this.props.onRemove) {
      this.props.onRemove(this.props.phase)
    }
  }

  _onRemoveItem (curGroup, activity) {
    const phase = this.props.phase
    _.remove(curGroup.items, (item, _idx) => item.dragId === activity.dragId)

    if (curGroup.items.length === 0) {
      _.remove(phase.groups, (group, _idx) => group.id === curGroup.id)
    }

    if (this.props.onItemRemove) {
      this.props.onItemRemove(activity)
    }

    if (activity.type === 'subtotal') {
      this.props.onDeleteSubtotal()
    } else if (this.props.onUpdateTotal) {
      this.props.onUpdateTotal()
    } else {
      this._onSave()
    }

    this.setState({ dataDate: new Date() })
  }

  _onUpdateItemEditable (group, activity) {
    const phase = this.props.phase

    let newActivityType = 'time-activity'
    if (this._isFilterByExpense()) {
      newActivityType = 'expense-activity'
    }

    if (this._isItemLastInGroup(group, activity.dragId)) {
      // If current group is the last group, then add new item, else find the next group and make
      // first item active
      if (this._isGroupLast(phase, group.id)) {
        group.items.push(
          this._createNewActivity(newActivityType, phase, group.id)
        )
      } else {
        const nextGroupIndex = group.id + 1
        const nextGroup = phase.groups[nextGroupIndex]
        if (nextGroup) {
          const nextGroupItems = this._getFilteredItems(nextGroup.items)
          if (nextGroupItems.length === 0) {
            nextGroup.items.push(
              this._createNewActivity(newActivityType, phase, nextGroup.id)
            )
          } else {
            nextGroupItems[0].editable = 'title'
          }
        }
      }
    } else {
      const itemIdx = this._getItemIndex(group, activity.dragId)
      const groupItems = this._getFilteredItems(group.items)

      groupItems.map((item, idx) => {
        if (idx === itemIdx + 1) {
          item.editable = 'title'
        }
        return ''
      })
    }
  }

  _getItemIndex (group, itemDragId) {
    let itemIdx = 0
    const items = this._getFilteredItems(group.items)
    items.map((item, idx) => {
      if (item.dragId === itemDragId) {
        itemIdx = idx
      }
      return ''
    })

    return itemIdx
  }

  _isItemLastInGroup (group, itemDragId) {
    const items = this._getFilteredItems(group.items)
    const itemsCount = items.length
    if (itemsCount === 0) {
      return true
    }

    let lastItemIndex = itemsCount - 1
    const lastItem = items[lastItemIndex]
    if (lastItem.type === 'subtotal') {
      lastItemIndex = itemsCount > 1 ? itemsCount - 2 : -1
    }

    return this._getItemIndex(group, itemDragId) === lastItemIndex
  }

  _isGroupLast (phase, groupIndex) {
    return phase.groups.length === groupIndex + 1
  }

  _handleSearchPhase (keyword) {
    this.props.phase.title = keyword
    this.data.phaseKeyword = keyword
    this.setState({ dataDate: new Date() })
  }

  _handlePhaseTitleSelect (obj) {
    const phase = this.props.phase
    phase.title = obj.label

    this.data.phaseKeyword = ''

    // If activities are empty then copy from project budget phase
    if (
      phase.groups.length === 1 &&
      phase.groups[0].items.length === 0 &&
      this.props.processPhaseSelect
    ) {
      this.props.processPhaseSelect(phase.title, phaseItems => {
        if (phaseItems) {
          phase.groups[0].items = phaseItems
          this._moveToPhaseActivity()
        }

        this._onSave()
        this.setState({ dataDate: new Date() })
      })
    } else {
      this._onSave()
      this.setState({ dataDate: new Date() })
    }

    this._onSave()
    this.setState({ dataDate: new Date() })
  }

  _handlePhaseTitleBlur () {
    const phase = this.props.phase

    this.data.phaseKeyword = ''
    phase.editable = phase.bEdit ? false : 'daterange'

    this._onSave()
    this.setState({ dataDate: new Date() })
  }

  /* Private functions */
  _onToggleExpand (bExpand, phase, ev) {
    ev.preventDefault()
    phase.expanded = bExpand
    if (this.props.onPhaseToggle) {
      this.props.onPhaseToggle()
    }
    this.setState({ dataDate: new Date() })
  }

  _onSettings (phase, e) {
    e.preventDefault()

    if (this._references.phaseSettingDialog.current) {
      this._references.phaseSettingDialog.current.show(
        this.props.projectTitle,
        this.props.contactName,
        phase
      )
    }
  }

  _onDelete (ev) {
    ev.preventDefault()

    let bItemUsed = false
    const phase = this.props.phase
    if (phase.groups && phase.groups.length > 0) {
      phase.groups.map(group => {
        bItemUsed = _.find(group.items, item => {
          return item.bUsed === true
        })
      })
    }

    if ((!bItemUsed) && this.props.onRemove) {
      this.props.onRemove(this.props.phase)
      if (this._references.phaseSettingDialog.current) {
        this._references.phaseSettingDialog.current.hide()
      }
    }
  }

  _onCopy (ev) {
    ev.preventDefault()
    if (this.props.onCopy) {
      this.props.onCopy(this.props.phase)
      if (this._references.phaseSettingDialog.current) {
        this._references.phaseSettingDialog.current.hide()
      }
    }
  }

  _renderEstimatePhaseHeader () {
    const { phase, isDiscountPhase } = this.props
    const canChangeStatus = this._isEditEnabled() || Acl.isReopenAllowed()
    const phaseLen = this.props.budget.phases.length
    const connectDragSource = this.props.connectDragSource || this._connectDragSource

    // If any activity is linked to timer, dont allow to change to estimate status
    let disableEsimateStatus = false
    for (const group of phase.groups) {
      for (const item of group.items) {
        if (item.timeSpent > 0) {
          disableEsimateStatus = true
        }
      }
    }

    // Check can be deleted
    const canDelete = !(
      !this._isEditEnabled() ||
      phase.spentAmount > 0 ||
      phase.status === 'closed'
    )
    let phaseHeaderClassName = 'phaseheader estimate '
    if (this.props.showRate) {
      phaseHeaderClassName += 'showrate'
    } else if (this.props.showTax) {
      phaseHeaderClassName += 'showtax'
    } else {
      phaseHeaderClassName += 'showactivity'
    }

    return (
      <div className={phaseHeaderClassName}>
        <div className='phaseheader-inner'>
          {canDelete && !phase.editable && phaseLen > 1 && (
            <span
              className='phaseheader-close'
              onClick={this._onClickDeletePhase.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          {phase.expanded && !phase.editable && phaseLen > 1 && (
            <span
              className='phaseheader-accordion'
              onClick={this._onToggleExpand.bind(this, false, phase)}
            >
              <i className='icon icon-planner-accordionclose' />
            </span>
          )}
          {!phase.expanded && !phase.editable && phaseLen > 1 && (
            <span
              className='phaseheader-accordion'
              onClick={this._onToggleExpand.bind(this, true, phase)}
            >
              <i className='icon icon-planner-accordionopen' />
            </span>
          )}
          <div className='phaseheader-hovercontent'>
            <IconButton
              icon='common-action-setting'
              size='small'
              onClick={this._onSettings.bind(this, phase)}
            />
          </div>
          <div className='cont'>
            {this._renderPhaseHeaderTitle()}
            <div
              className={`col colspent${
                phase.total > 1000000 ? ' coltextsmall' : ''
              }`}
            >
              {phase.total !== 0 && phase.total !== '' && this.props.isEstimate
                ? (
                  <span className='spent'>
                    <PriceText value={phase.total} />
                  </span>
                ) : app.projectSetting.showProMemoria
                  ? (
                    <IntlMessage ident='project.viewBudget.proMemoria' />
                  )
                  : ('')}
            </div>
          </div>
          {!phase.editable &&
            !isDiscountPhase &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
          {canChangeStatus && (
            <PopupBudgetStatus
              ref={this._references.phasestatus}
              status={phase.status}
              disableEsimateStatus={disableEsimateStatus}
              target={this._references.triggerStatus.current}
              container={this}
              closeDate={this.props.projectCloseDate}
              onChange={this._onChangePhaseStatus.bind(this)}
            />
          )}
          <ConfirmDelete
            ref={this._references.phaseConfirmDelete}
            title='project.viewBudget.msgConfirmDelete'
            onClickOk={this._onDeletePhase.bind(this)}
          />
          <DialogPhaseSetting
            ref={this._references.phaseSettingDialog}
            showdelete={canDelete && !phase.editable && phaseLen > 1}
            deleteMessage='project.viewBudget.msgConfirmDelete'
            onDelete={this._onDelete.bind(this)}
            onCopy={this._onCopy.bind(this)}
            phase={phase}
          />
        </div>
        {!phase.showAdd && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowPhaseAddAction.bind(this, true)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
      </div>
    )
  }

  _renderProjectPhaseHeader () {
    const phase = this.props.phase
    const canChangeStatus = this._isEditEnabled() || Acl.isReopenAllowed()

    const bShowReorder = true
    const phaseLen = this.props.budget.phases.length
    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource

    // If any activity is linked to timer, dont allow to change to estimate status
    let disableEsimateStatus = false
    for (const group of phase.groups) {
      for (const item of group.items) {
        if (item.timeSpent > 0) {
          disableEsimateStatus = true
        }
      }
    }

    // Check can be deleted
    const canDelete = !(
      !this._isEditEnabled() ||
      phase.spentAmount > 0 ||
      phase.status === 'closed'
    )
    const phaseHeaderClassName = classnames('phaseheader', 'project', {
      hidedate: this.props.hideDateRange || !this.props.showDate,
      hasoverspent: phase.overSpent > 0
    })

    let totalBudget = 0
    let totalSpentAmount = 0
    let totalInvoicedByActuals = 0
    const { filterType } = this.props
    const isFilterExpense = filterType === 'expense' || filterType === 'all'
    const isFilterTime = filterType === 'time' || filterType === 'all'

    phase.groups.forEach(group => {
      group.sellingPrice = calculateGroupSellingPrice(group.items)
      group.items.forEach(item => {
        if (item.invoicedByActuals) {
          totalInvoicedByActuals += parseFloat(item.invoicedByActuals)
        }
        if (item.type === 'expense-activity') {
          if (isFilterExpense) {
            totalBudget += parseFloat(item.total)
            totalSpentAmount += parseFloat(item.spentAmount)
          }
        } else if (item.type === 'time-activity') {
          if (isFilterTime) {
            totalBudget += parseFloat(item.total)
            totalSpentAmount += parseFloat(item.spentAmount)
          }
        }
      })
    })
    phase.sellingPrice = phase.groups.reduce(
      (prevValue, currValue) => prevValue + parseFloat(currValue.sellingPrice),
      0
    )

    return (
      <div className={phaseHeaderClassName}>
        <div className='phaseheader-inner'>
          {canDelete && !phase.editable && phaseLen > 1 && (
            <span
              className='phaseheader-close'
              onClick={this._onClickDeletePhase.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          {phase.expanded && !phase.editable && phaseLen > 1 && (
            <span
              className='phaseheader-accordion'
              onClick={this._onToggleExpand.bind(this, false, phase)}
            >
              <i className='icon icon-planner-accordionclose' />
            </span>
          )}
          {!phase.expanded && !phase.editable && phaseLen > 1 && (
            <span
              className='phaseheader-accordion'
              onClick={this._onToggleExpand.bind(this, true, phase)}
            >
              <i className='icon icon-planner-accordionopen' />
            </span>
          )}
          <div className='phaseheader-hovercontent'>
            <IconButton
              icon='common-action-setting'
              size='small'
              onClick={this._onSettings.bind(this, phase)}
            />
          </div>
          <div className='cont'>
            {this._renderPhaseHeaderTitle()}
            <div
              className={classnames('col colbudget', {
                coltextsmall: useSmallText(phase, totalInvoicedByActuals)
              })}
            >
              {phase.total !== 0 &&
              phase.total !== '' &&
              !this.props.isEstimate
                ? (
                  <span className='budget'>
                    <PriceText value={totalBudget} />
                  </span>
                ) : (
                  ''
                )}
            </div>
            {phase.sellingPrice !== 0 && phase.sellingPrice !== '' && !this.props.isEstimate && (
              <div
                className={classnames('col colsellingprice', {
                  coltextsmall: useSmallText(phase, totalInvoicedByActuals)
                })}
              >
                <span className='sellingprice'>
                  <PriceText value={phase.sellingPrice.toFixed(2)} />
                </span>
              </div>
            )}
            <div
              className={classnames('col colspent', {
                coltextsmall: useSmallText(phase, totalInvoicedByActuals)
              })}
            >
              {phase.total !== 0 && phase.total !== '' && !this.props.isEstimate ? (
                <span className='spent'>
                  <PriceText value={totalSpentAmount} />
                </span>
              ) : (
                ''
              )}
              {phase.total !== 0 && phase.total !== '' && this.props.isEstimate ? (
                <span className='spent'>
                  <PriceText value={phase.total} />
                </span>
              ) : ('')}
            </div>
            {totalInvoicedByActuals !== 0 && (
              <div className={classnames('col colinvoiced', { coltextsmall: useSmallText(phase, totalInvoicedByActuals) })}>
                <span className='spent'>
                  <PriceText value={totalInvoicedByActuals} />
                </span>
              </div>
            )}
          </div>
          {this.props.isEstimate && (
            <div className='splitbrder splitbrder-colprogress' />
          )}
          {this.props.isEstimate && (
            <div className='splitbrder splitbrder-colbudget' />
          )}
          {!phase.editable &&
            bShowReorder &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
          {canChangeStatus && (
            <PopupBudgetStatus
              ref={this._references.phasestatus}
              status={phase.status}
              disableEsimateStatus={disableEsimateStatus}
              target={this._references.triggerStatus.current}
              container={this}
              closeDate={this.props.projectCloseDate}
              onChange={this._onChangePhaseStatus.bind(this)}
            />
          )}
          <ConfirmDelete
            ref={this._references.phaseConfirmDelete}
            title='project.viewBudget.msgConfirmDelete'
            onClickOk={this._onDeletePhase.bind(this)}
          />
          <DialogPhaseSetting
            ref={this._references.phaseSettingDialog}
            showdelete={canDelete && !phase.editable && phaseLen > 1}
            deleteMessage='project.viewBudget.msgConfirmDelete'
            onDelete={this._onDelete.bind(this)}
            onCopy={this._onCopy.bind(this)}
            phase={phase}
          />
        </div>
        {phase.expanded && (phase.status === 'active' || phase.status === 'estimate') && !phase.showAdd && !this.props.isEstimate && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowPhaseAddAction.bind(this, true)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
      </div>
    )
  }

  _renderPhaseHeaderTitle () {
    const phase = this.props.phase
    const currStatus = phase.status.toLowerCase()
    const canChangeStatus = this._isEditEnabled() || Acl.isReopenAllowed()
    const statusClass = `progress ${currStatus}${
      !canChangeStatus ? ' disabled' : ''
    }`

    if (this.props.isEstimate) {
      return (
        <div
          className='col coltitle'
          onClick={this._onEditPhase.bind(this, 'title')}
        >
          {this._renderPhaseTitle()}
          {this._renderPhaseDate()}
        </div>
      )
    } else {
      return (
        <div className='col coltitle'>
          <div className='phasetitle'>
            {this._renderPhaseTitle()}
            <span
              className={statusClass}
              ref={this._references.triggerStatus}
              onClick={canChangeStatus ? this._onClickStatus.bind(this) : null}
            >
              {IntlUtil.convertMessage(Util.getTranslatedStatus(phase.status))}
            </span>
          </div>
          {this._renderPhaseDate()}
        </div>
      )
    }
  }

  _renderPhaseTitle () {
    const phase = this.props.phase
    if (phase.editable === 'title') {
      if (this.props.isEstimate) {
        const _className = classnames(
          'bdgtphaseinput bdgtphaseinput_autocomplete',
          {}
        )

        return (
          <span className={_className}>
            <FormAutoComplete
              label='project.viewBudget.phaseInputPlaceholder'
              name='title'
              autoFocus
              value={phase.title}
              displayValue={phase.title}
              options={[]}
              onChange={this._handleSearchPhase.bind(this)}
              onSelect={this._handlePhaseTitleSelect.bind(this)}
              onBlur={this._handlePhaseTitleBlur.bind(this)}
              onKeyDown={this._onKeyPressTitleInput.bind(this, false)}
              hideAdd
              hasAutoSelect={false}
            />
          </span>
        )
      } else {
        const _className = classnames(
          'bdgtphaseinput bdgtphaseinput_autocomplete',
          {}
        )

        return (
          <span className={_className}>
            <FormAutoComplete
              label='project.viewBudget.phaseInputPlaceholder'
              name='title'
              autoFocus
              value={phase.title}
              displayValue={phase.title}
              options={[]}
              onChange={this._handleSearchPhase.bind(this)}
              onSelect={this._handlePhaseTitleSelect.bind(this)}
              onBlur={this._handlePhaseTitleBlur.bind(this)}
              onKeyDown={this._onKeyPressTitleInput.bind(this, false)}
              hideAdd
              hasAutoSelect={false}
            />
          </span>
        )
      }
    }

    if (this.props.isEstimate) {
      return (
        <span className='title'>
          {phase.title ? (
            phase.title
          ) : (
            <span className='label'>
              <IntlMessage ident='project.viewBudget.phaseInputPlaceholder' />
            </span>
          )}
        </span>
      )
    } else {
      return (
        <span className='title' onClick={this._onEditPhase.bind(this, 'title')}>
          {phase.title ? (
            phase.title
          ) : (
            <span className='label'>
              <IntlMessage ident='project.viewBudget.phaseInputPlaceholder' />
            </span>
          )}
        </span>
      )
    }
  }

  _renderPhaseDate () {
    if (this.props.hideDateRange) {
      return ''
    }

    const phase = this.props.phase
    if (this.props.isEstimate) {
      return null
    }

    if (phase.editable === 'daterange') {
      return (
        <span className='date'>
          <DateRangePicker
            startDate={phase.fromDate}
            endDate={phase.toDate}
            active
            highlightedPeriods={[
              {
                from: this.props.projectStartDate,
                to: this.props.projectEndDate
              }
            ]}
            onClose={this._onCloseDate.bind(this, phase)}
            onSelect={this._onSelectDate.bind(this)}
          />
        </span>
      )
    } else {
      return (
        <span
          className='date'
          onClick={this._onEditPhase.bind(this, 'daterange')}
        >
          {this.props.isEstimate
            ? this._renderDate(phase)
            : this._renderProjectPhaseDate(phase)}
        </span>
      )
    }
  }

  _renderDate (phase) {
    // Intially If fromDate and toDate are null return label
    if (phase.fromDate === null && phase.toDate === null) {
      return ''
      // If toDate is null or 0 return fromDate alone
    } else if (
      phase.toDate === 0 ||
      (phase.toDate === null && phase.fromDate !== null)
    ) {
      return `${DateUtil.getDisplayDate(phase.fromDate)}`
      // else return fromDate and ToDate
    } else {
      return `${DateUtil.getDisplayDate(
        phase.fromDate
      )} - ${DateUtil.getDisplayDate(phase.toDate)} `
    }
  }

  _renderProjectPhaseDate (phase) {
    if (
      phase.toDate === 0 ||
      (phase.toDate === null && phase.fromDate !== null)
    ) {
      return (
        <div className='date'>{DateUtil.getDisplayDate(phase.fromDate)}</div>
      )
    } else if (phase.fromDate && phase.toDate) {
      return (
        <div className='date'>
          {DateUtil.isDateEqual(phase.fromDate, phase.toDate)
            ? `${DateUtil.getDisplayDate(phase.fromDate)}`
            : `${DateUtil.getDisplayDate(
                phase.fromDate
              )} - ${DateUtil.getDisplayDate(phase.toDate)}`}
        </div>
      )
    } else if (this.props.projectStartDate && this.props.projectEndDate) {
      return (
        <div className='date default'>
          {DateUtil.isDateEqual(
            this.props.projectStartDate,
            this.props.projectEndDate
          )
            ? `${DateUtil.getDisplayDate(this.props.projectStartDate)}`
            : `${DateUtil.getDisplayDate(
                this.props.projectStartDate
              )} - ${DateUtil.getDisplayDate(this.props.projectEndDate)}`}
        </div>
      )
    } else if (this.props.projectStartDate && !this.props.projectEndDate) {
      return (
        <div className='date default'>
          {`${DateUtil.getDisplayDate(this.props.projectStartDate)} - `}
          <span className='infinty'>&infin;</span>
        </div>
      )
    } else if (!this.props.projectStartDate && this.props.projectEndDate) {
      return (
        <div className='date default'>
          <span className='infinty'>&infin; -</span>
          {` ${DateUtil.getDisplayDate(this.props.projectEndDate)}`}
        </div>
      )
    } else {
      return (
        <div className='date default'>
          <IntlMessage ident='project.viewBudget.addDateLabel' />
        </div>
      )
    }
  }

  _renderPhaseGroups () {
    const phase = this.props.phase
    const _className = classnames('itemgroup', {
      hasitemdragging: this.props.isItemDragging
    })

    if (phase.groups && phase.groups.length > 0) {
      return phase.groups.map((group, idx) => {
        return (
          <div key={idx}>
            <div className={_className}>
              {this._renderPhaseGroupContent(group)}
            </div>
          </div>
        )
      })
    }

    return ''
  }

  _renderPhaseGroupContent (group) {
    const phase = this.props.phase
    let items = this._getFilteredItems(group.items)
    if (this._isFilterByExpense()) {
      items = _.filter(items, obj => obj.type === 'expense-activity')
    } else if (this._isFilterByTime()) {
      items = _.filter(items, obj => obj.type === 'time-activity')
    }

    if (items && items.length > 0) {
      return items.map((item, idx) => {
        if (this.props.isEstimate) {
          return (
            <EstimateBudgetItem
              budget={this.props.budget}
              calculateSpentAmount={this.props.calculateSpentAmount}
              disabledEdit={!this._isEditEnabled()}
              estimateRateCards={this.props.estimateRateCards}
              filterType={this.props.filterType}
              getItemIndex={this._getItemIndex.bind(this, group)}
              getItemPosition={this.props.getItemPosition}
              hideDateRange={this.props.hideDateRange}
              hidePagebreak={group.items.length === idx + 1}
              isDiscountPhase={this.props.isDiscountPhase}
              isEstimate={this.props.isEstimate}
              isQuickbookConnected={this.props.isQuickbookConnected}
              item={item}
              key={idx}
              onChange={this._onChangeActivity.bind(this, group, item)}
              onCreateContact={this.props.onCreateContact}
              onCreateItemSupplier={this.props.onCreateItemSupplier}
              onCreatePurchaseOrder={this.props.onCreatePurchaseOrder}
              onCreateTaxRate={this.props.onCreateTaxRate}
              onDeleteItemSupplier={this.props.onDeleteItemSupplier}
              onDragEnd={this.props.onDragEnd}
              onDragStart={this.props.onDragStart}
              onInsertItemInMiddle={this._onInsertItemInMiddle.bind(this, item)}
              onItemCreate={this.props.onItemCreate}
              onItemUpdate={this.props.onItemUpdate}
              onMoveItem={this.props.onMoveItem}
              onRemove={this._onRemoveItem.bind(this, group, item)}
              onSave={this._onSaveActivity.bind(this, group, item)}
              onSearchSupplier={this.props.onSearchSupplier}
              onUpdateEditable={this._onUpdateItemEditable.bind(this, group, item)}
              onUpdateTotal={this.props.onUpdateTotal.bind(this)}
              onViewPurchaseOrder={this.props.onViewPurchaseOrder}
              phaseStatus={phase.status}
              processNextActivityId={this._processNextActivityId.bind(this)}
              quickbookItems={this.props.quickbookItems}
              rate={this.props.rate}
              rateCards={this.props.rateCards}
              rateMarkup={this.props.rateMarkup}
              reloadQuickbookItems={this.props.reloadQuickbookItems}
              showActivity={this.props.showActivity}
              showDate={this.props.showDate}
              showDefaultVat={this.props.showDefaultVat}
              showLabelType={this.props.showLabelType}
              showRate={this.props.showRate}
              showTax={this.props.showTax}
              showVatAutocomplete={this.props.showVatAutocomplete}
              taxRateVatOptions={this.props.taxRateVatOptions}
              vatLevels={this.props.vatLevels}
            />
          )
        }

        return (
          <ProjectBudgetItem
            calculateMarkupPercentage={this.props.calculateMarkupPercentage}
            calculateSellingPrice={this.props.calculateSellingPrice}
            calculateSpentAmount={this.props.calculateSpentAmount}
            disabledEdit={!this._isEditEnabled()}
            estimateRateCards={this.props.estimateRateCards}
            filterType={this.props.filterType}
            getItemIndex={this._getItemIndex.bind(this, group)}
            getItemPosition={this.props.getItemPosition}
            isEstimate={false}
            isQuickbookConnected={this.props.isQuickbookConnected}
            item={item}
            key={item.id}
            onAddExpense={this.props.onAddExpense}
            onChange={this._onChangeActivity.bind(this, group, item)}
            onCreateContact={this.props.onCreateContact}
            onCreateItemSupplier={this.props.onCreateItemSupplier}
            onCreatePurchaseOrder={this.props.onCreatePurchaseOrder}
            onDeleteItemSupplier={this.props.onDeleteItemSupplier}
            onDragEnd={this.props.onDragEnd}
            onDragStart={this.props.onDragStart}
            onEditExpense={this.props.onEditExpense}
            onInsertItemInMiddle={this._onInsertItemInMiddle.bind(this, item)}
            onItemCreate={this.props.onItemCreate}
            onItemUpdate={this.props.onItemUpdate}
            onMoveItem={this.props.onMoveItem}
            onRemove={this._onRemoveItem.bind(this, group, item)}
            onSave={this._onSaveActivity.bind(this, group, item)}
            onSearchSupplier={this.props.onSearchSupplier}
            onUpdateEditable={this._onUpdateItemEditable.bind(this, group, item)}
            onUpdateTotal={this.props.onUpdateTotal.bind(this)}
            onViewPurchaseOrder={this.props.onViewPurchaseOrder}
            phaseFromDate={phase.fromDate}
            phaseStatus={phase.status}
            phaseToDate={phase.toDate}
            poDownloadBaseUrl={this.props.poDownloadBaseUrl}
            processNextActivityId={this._processNextActivityId.bind(this)}
            projectEndDate={this.props.projectEndDate}
            projectStartDate={this.props.projectStartDate}
            quickbookItems={this.props.quickbookItems}
            rate={this.props.rate}
            rateCards={this.props.rateCards}
            rateMarkup={this.props.rateMarkup}
            reloadQuickbookItems={this.props.reloadQuickbookItems}
            showDate={!this.props.hideDateRange && this.props.showDate}
            showLabelType={this.props.showLabelType}
          />
        )
      })
    }

    return ''
  }

  _onShowPhaseAddAction (bShowAdd) {
    const phase = this.props.phase
    phase.showAdd = bShowAdd

    this.setState({ dataDate: new Date() })
  }

  _processNextActivityId () {
    if (this.props.budget) {
      return this.props.budget.lastActivityId++
    }

    return 0
  }

  _isFilterByExpense () {
    return this.props.filterType === 'expense'
  }

  _isFilterByTime () {
    return this.props.filterType === 'time'
  }

  _getFilteredItems (items) {
    if (this._isFilterByExpense()) {
      return _.filter(items, obj => obj.type === 'expense-activity')
    } else if (this._isFilterByTime()) {
      return _.filter(items, obj => obj.type === 'time-activity')
    }

    return items
  }

  _isEditEnabled () {
    const phaseStatus = this.props.phase.status
    return (
      !this.props.disabledEdit &&
      (phaseStatus === 'active' || phaseStatus === 'estimate')
    )
  }

  _connectDragSource (node) {
    return node
  }
}

export default EstimateBudgetPhaseBase
